<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">

        <el-carousel :interval="5000" style="width: 100%;height: 100%;" @change="carouselChange">
          <el-carousel-item v-for="item in 3" :key="item">
            <div v-if="item == 1" class="top-class">
              <div>
                <div class="page">
                  <h3>安徽星启仪实验室设备有限公司</h3>
                </div>
                <p class="slogan">创新驱动、品质为本、服务至上</p>
                <div class="slogan" style="padding-top:0;font-size: 35px;color: blue;">0 元定制设计 自有工厂 免费获取厂家报价</div>

              </div>
              <img src="../assets/img/project/tfsb/tfsb5.png">
            </div>
            <div v-else-if="item == 2" class="top-class">
              <img src="../assets/img/project/qgsyt/qgsyt1.png">
              <div>
                <div class="page">
                  <h3>安徽星启仪实验室设备有限公司</h3>
                </div>
                <p class="slogan">专注打造现代化试验工程</p>
                <div class="slogan" style="padding-top:0;color: red;font-size: 40px;">订购热线：17856527848 </div>
              </div>

            </div>
            <div v-else class="top-class">
              <div>
                <div class="page">
                  <h3>安徽星启仪实验室设备有限公司</h3>
                </div>
                <p class="slogan">专注于实验室家具及实验室装修整体解决方案的专业公司</p>
                <div class="slogan" style="padding-top:0;color: red;font-size: 40px;">订购热线：17856527848 </div>
              </div>
              <img src="../assets/img/project/jhsys/jhsys4.png">
            </div>

          </el-carousel-item>
        </el-carousel>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">

        <div class="swiper-page">
          <div class="page">
            <div class="title-common">产品中心</div>
            <!-- <p>PRODUCT</p> -->
          </div>
          <ul class="case-item ">
            <li v-for="(item, index) in ProjectList" :key="index" v-lazy:background-image="item.img">
              <router-link class="text-decoration" :to="{ name: 'product', params: { title: item.title } }">
                <div class="case-item-hover">
                  <p class="hover-title">{{ item.title }}</p>
                  <div class="bottom"></div>
                  <div class="more">
                    <span>MORE</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
        <div class="container" style="transform:scale(0.85)">
          <div class="row">
            <div class="col-md-6" :class="{ 'fade-in': activeIndex == 2 }">
              <div class="about-img fadeInLeft  wow animated" style="visibility: visible; animation-name: fadeInLeft;">
                <img src="../assets/img/about-index.jpg">
              </div>
            </div>
            <div class="col-md-6" :class="{ 'fade-in2': activeIndex == 2 }">
              <div class="about-con fadeInRight  wow animated"
                style="visibility: visible; animation-name: fadeInRight;">
                <div class="tit">
                  <h4>公司简介</h4>
                  <p>about us</p>
                </div>
                <div class="con scaletoOnex`">
                  <span style="white-space:normal;">&nbsp;&nbsp;</span>
                  <strong style="white-space:normal;">&nbsp;</strong>
                  <a target="_blank" style="white-space:normal;">
                    <strong>安徽星启仪实验室设备有限公司</strong>
                  </a>
                  <span style="white-space:normal;">是一家集实验室规划设计、设备研发、生产制造、工程安装及售后服务于一体的现代化高新技术企业。公司以“创
                    新驱动、品质为本、服务至上”为核心理念，致力于为科研机构、高校、医药、化工、环保等行业提供安全、智能、环保的实验室整体解决方案。</span>
                  <!-- <a href="http://www.jxoubo.com/" target="_blank" style="white-space:normal;">
                    <strong>实验台</strong>
                  </a> --><span style="white-space:normal;">公司专注于实验室家具(全钢/钢木/铝木实验台、通风柜、药品柜等)、实验室通风系统、环保
                    净化系统、洁净工程及实验室智能化管理系统的研发与生产。依托先进的生产基地和严格的质量管理体系(通过ISO9001、ISO14001认证),产品以
                    高精度、耐腐蚀、环保节能为特色，符合国际标准(如美国SEFA协会标准)。
                  </span><br>
                </div>
                <div class="more">
                  <a @click="gotoDetail('goin')">了解更多</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper class="swiper-slide slide-four">
        <div class="container2">
          <div class="tit-box text-center mt50 fadeInUp wow  animated"
            style="visibility: visible; animation-name: fadeInUp;">
            <div class="title-common" style="transform: scale(0.75)">我们的优势</div>
            <p>让高质量的产品乘着环宇风帆，冲出亚洲、走向世界</p>
          </div>
          <div class="row">
            <el-carousel height="150px">
              <el-carousel-item v-for="(item, index) in EdgeList" :key="index">
                <li class="clearfix li1 fadeInUp wow  animated" style="visibility: visible; animation-name: fadeInUp;">
                  <div class="col-md-8">
                    <div class="ys-con">
                      <h4><span>0{{ index + 1 }}.</span>{{ item.title }}</h4>
                      <p>{{ item.descrip }}</p><a @click="gotoDetail('product')">了解更多</a>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="ys-img">
                      <img :src="item.img">
                    </div>
                  </div>
                </li>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </swiper>
      <swiper-slide class="swiper-slide ">
        <div class="container">
          <div class="tit-box text-center mt50 fadeInUp wow  animated"
            style="visibility: visible; animation-name: fadeInUp;">
            <div class="title-common" style="transform: scale(0.75)">经典案例</div>
            <p style="margin-bottom: 10px;">让高质量的产品乘着环宇风帆，冲出亚洲、走向世界</p>
          </div>
          <div class="row slide-five">
            <ul>
              <li v-for="(item, index) in caseList.slice(0, 4)" :key="index" class="fadeInUp  wow col-md-6 animated"
                data-wow-delay="0.1s" style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="case-item1 clearfix">
                  <a @click="gotoDetail('case')" :title="item.Title">
                    <div class="img left"><img :src="item.Img[0]" :alt="item.Title"></div>
                    <div class="con">
                      <h4>{{ item.Title }}</h4>
                      <p>{{ item.descrip }}</p>
                      <div class="more"><span>more</span></div>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide ">
        <div class=" slide-six ">
          <div class="footer-home " :class="{ 'fade-in-delay': activeIndex == 5 }">
            <div class="footer-info">
              <div class="footer-home-content">
                <p style="margin-bottom: 20px;">联系我们</p>
                <span>邮箱：17856527848@163.com</span>
                <span>电话：17856527848</span>
                <span>网址：www.xqylab.com</span>
                <span>地址：安徽省合肥市庐阳区阜南路东怡金融广场B座2604室</span>
              </div>
              <img src="@/assets/img/ercode.png" alt />
            </div>

          </div>

        </div>
      </swiper-slide>
      <!-- <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in newsList" :key="i">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <router-link class="text-decoration" :to="{ name: 'newsdetails', params: { id: news.Id } }">
                <div class="item-img" v-lazy:background-image="imgserver + news.Img"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3>{{ news.Title || 测试标题 }}</h3>
              <p>{{ news.Content || 测试内容 }}</p>
              <span>{{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </swiper-slide> -->
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { caseList } from "@/config.js"
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      carouselIndex: 0,
      caseList,
      EdgeList: [
        {
          title: '实验室设备全周期服务解决方案',
          descrip: '我们始终以客户需求为核心，通过深度技术沟通与需求分析，精准锁定实验场景的功能定位与技术参数，为您量身定制涵盖设备选型、材料甄选、工艺优化的全周期服务方案。依托严苛的品控体系与行业领先的制造工艺，从304不锈钢防腐处理到精密数控加工，每一道工序均执行国际标准，确保产品性能稳定性和安全合规性。凭借累计服务超过200家行业领军企业的丰富经验，我们整合前沿技术资源，提供智能化实验室管理系统与模块化扩展方案，助力科研机构及企业实现实验效率提升40%以上，全流程服务覆盖方案设计、生产交付、安装调试及终身维保，真正实现“交钥匙工程”的无忧体验。',
          img: require('@/assets/img/aboutUs.jpg')
        },
        {
          title: '创新引领·智造标杆——实验室空间规划专家',
          descrip: '公司汇聚国家级工业设计团队，依托三维可视化BIM系统，为生物制药、检验检测等领域客户提供兼具功能性与美学价值的实验室空间规划方案。持续深耕科技创新领域，深度融合德系工业设计理念与美式实验室模块化经验，结合300+项目落地经验沉淀出创新方法论，实现通风系统流体力学仿真、智能控制系统二次开发等核心技术自主可控，形成"设计-工程-运维"全链路闭环解决方案。',
          img: require('@/assets/img/edge2.jpg')
        },
        {
          title: '规模效应·战略占位——高性价比市场攻坚模式',
          descrip: '针对市场白热化竞争阶段，通过全渠道成本管控体系与智能柔性生产系统协同发力，在确保产品核心性能达标前提下，实施梯度定价策略。依托规模化集采优势降低边际成本，结合动态价格调节机制快速渗透中端市场，实现装机量同比提升60%的同时，构建"高市占率-强供应链-优服务闭环"三维渗透率增长模型，形成以量变驱动质变的良性竞争壁垒。',
          img: require('@/assets/img/edge3.jpg')
        },
        {
          title: '全维守护·极速响应——实验室设备全周期维保体系',
          descrip: '我们构建"30分钟远程诊断+24小时现场响应"的双层保障机制：合肥区域接到报修后120分钟内抵达现场，省内其他地区48小时、省外地区72小时全境覆盖，同步启动备件直供体系确保维修时效。依托智能派单系统与原厂技师团队，实现98%工单24小时闭环，关键设备故障率下降65%。提供预防性维护、参数校准等增值服务，通过ISO55000资产管理认证，以"原厂品质+军工级服务"标准守护设备全生命周期价值。',
          img: require('@/assets/img/edge4.jpg')
        },
      ],
      loading: false,
      ProjectList: [{
        title: "实验台",
        img: require('@/assets/img/case/PP实验台.jpg')
      }, {
        title: "实验室设备",
        img: require('@/assets/img/case/天平台.jpg')
      }, {
        title: "实验室通风系统",
        img: require('@/assets/img/case/实验室通风系统.jpg')
      }, {
        title: "通风柜",
        img: require('@/assets/img/case/PP通风柜.jpg')
      }, {
        title: "反辐射工程",
        img: require('@/assets/img/case/实验室铅门.jpg')
      }, {
        title: "实验室净化",
        img: require('@/assets/img/case/实验室净化.jpg')
      }, {
        title: "实验室气体管路",
        img: require('@/assets/img/case/气体管路.jpg')
      }],
      newsList: [{}, {}, {}],
      activeIndex: 0,
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            this.activeIndex = this.$refs.mySwiper.swiper.activeIndex;
            /*  console.log('this.$refs.mySwiper.swiper;',) */
          }
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      }
    };
  },
  created() { },
  methods: {
    carouselChange(val) {
      this.carouselIndex = val;
    },
    gotoDetail(type) {
      this.$router.push({
        name: type
      })
    }
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    /* this.$http
      .all([
        this.$http.get("Cases/GetCasesAll"),
        this.$http.get(`News?type=1&num=3`)
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data;
          this.newsList = responseNews.data;
          this.loading = false;
        })
      ); */
  }
};
</script>

<style lang="scss" scoped>
::v-deep.el-carousel__container {
  height: 100%;
}



::v-deep.el-carousel__arrow {
  height: 56px;
  width: 56px;
}

/* 基础渐入效果 */
.fade-in {
  animation: fadeIn 1.0s ease-in-out;
}

.fade-in2 {
  animation: fadeIn 3.0s ease-in-out;
}

/* 基础渐出效果 */
.fade-out {
  animation: fadeOut 1.5s ease-in-out;
}

/* 渐入动画定义 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* 渐出动画定义 */
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* 带延迟的渐入 */
.fade-in-delay {
  animation: fadeIn 0.1s ease-in-out 0.3s forwards;
  opacity: 0;
}

/* 组合效果：先渐出再渐入 */
.fade-out-in {
  animation:
    fadeOut 0.8s ease-out,
    fadeIn 0.8s ease-in 0.8s forwards;
}

.footer-home {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .footer-info {
    display: flex;
    justify-content: space-between;
    width: 70%;
    height: 350px;
    background: white;
    position: absolute;
    top: -70px;

    img {
      width: 300px;
      height: 300px;
    }
  }

  .footer-home-content {
    display: flex;
    flex-direction: column;



    padding: 20px;

    p {
      font-size: 22px;
      font-weight: bold;
      color: #333;
      line-height: 1.7;
    }

    span {
      height: 36px;
      line-height: 36px;
      font-size: 16px;
    }
  }

  .index-bg {
    width: 40%;
    height: 400px;
    padding: 20px;
    background: rgb(27, 120, 200);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}



/* .el-header {
  position: absolute;
} */


.top-class {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;

  img {
    /* margin-top: 40px; */
    width: 450px;
    height: 350px;
  }
}

.title-common {
  font-size: 40px !important;
  margin: 0 0 10px 0 !important;
  font-weight: bold !important;
  color: #333 !important;
  text-align: center;
}

.tit-box p[data-v-fae5bece] {
  font-size: 14px;
  color: #B7B7B7;
  text-transform: uppercase;
}

.tit-box h4[data-v-fae5bece] {
  font-size: 26px;
  margin: 0 0 10px 0;
  font-weight: bold;
  color: #333;
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-6 {
  width: 50%;
  float: left;
}

.about-img {
  visibility: visible;
  animation-name: fadeInLeft;
  position: relative;
  right: -40px;
  top: -30px;
  z-index: 2;
  box-shadow: 0 22px 40px rgba(0, 0, 0, .16);

  img {
    width: 100%;
  }
}

.about-con {
  visibility: visible;
  animation-name: fadeInRight;
  background: #fff;
  padding: 40px 40px 40px 100px;
  min-height: 320px;
  position: relative;
  left: -40px;
  z-index: 1;
}

.about-con .tit h4 {
  font-size: 24px;
  color: #005eae;
  margin-bottom: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.about-con .tit p {
  text-transform: uppercase;
  display: block;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #7c7c7c;
}

.about-con .con {
  margin: 20px 0 50px;
  font-size: 14px;
  color: #7c7c7c;
  line-height: 22px;
  /* height: 66px; */
  overflow: hidden;
}

.about-con .con a {
  color: red;
}

.about-con .more a {
  display: block;
  height: 40px;
  width: 160px;
  border: 1px solid #eee;
  text-align: center;
  line-height: 38px;
  color: #898989;
  font-size: 14px;
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
}

.about-con .more a:hover {
  color: #fff;
  background: #005eae;
}

.swiper-page {
  /* margin-top: -70px; */
  transform: scale(0.75);
}

.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    /* text-align: center; */
    /* height: 100px; */
    overflow: hidden;
    margin-top: 40px;

    h3,
    p {
      font-size: 40px;
      font-weight: 700;
      color: #fff;
      font-family: emoji;
    }
  }

  .slogan {
    animation-name: bounceInDown;
    animation-duration: 1s;
    /* text-align: center; */
    /* font-size: 50px; */
    color: black;
    padding: 30px 0;
  }
}

//经典案例
.case-item {
  width: 100%;
  height: 600px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  li {
    width: 23.66666667%;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 40px;
    color: #fff;
    font-size: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 60px;
    text-align: center;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 80px;
    border: 2px solid #fff;
    text-align: center;

    span {
      text-align: center;
      color: #fff;
      font-size: 20px;
    }
  }
}

// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  position: relative;
  width: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)),
    url(../assets/img/bgindex.jpg) center/cover;
  background-size: cover;

  ::v-deep.el-carousel__item {
    height: 510px!important;
  }

  ::v-deep.el-carousel__container {
    height: 510px!important;
  }
  ::v-deep.el-carousel__arrow{
    height: 45px;
    width: 45px;
    font-size: 20px;
  }
}


.bg1 {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}

.bg2 {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.bg3 {
  background: url(../assets/img/jianjietopmin.jpg) no-repeat center;
  background-size: cover;
}

/* .slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
} */

.slide-three {
  background: url(../assets/img/bgindex.jpg) no-repeat center;
  background-size: cover;
}

.slide-four {
  /*  background: linear-gradient(45deg, #66b1ffa1, #185a9d); */
  /* background: url(../assets/img/bgindex.jpg) no-repeat center;
  background-size: cover; */
}

.slide-six {
  background: url(../assets/img/aboutUs.jpg) no-repeat center;
  background-size: cover;
  height: calc(100% - 150px);
  margin-top: 150px;
}

.slide-five {
  /* background: url(../assets/img/home_do.jpg) no-repeat center; */
  background: linear-gradient(180deg, #96cdfda1, #185a9d);
  background-size: cover;

  li {
    margin: 15px 0;
  }

  ul {
    display: flex;
    justify-content: space-around;
    /* flex-wrap: wrap; */
    width: 100%;
    list-style-type: none;
  }

  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    .row {
      margin-right: -15px;
      margin-left: -15px;
    }

    .row::before {
      display: table;
      content: " ";
    }

    ol,
    ul,
    li,
    dl,
    dt,
    dd {
      list-style: none;
    }
  }

  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

  .col-md-6 {
    width: 23%;
    height: 350px;
    /* float: left; */
  }

  .case-item1 {
    background: #fff;
    position: relative;
  }

  a {
    text-decoration: none;
    color: #333;
    transition: all 0.3s;
  }

  .img {
    width: 100%;
    height: 240px;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .img:before {
    content: "";
    display: block;
    position: absolute;
    border: 1px solid #fff;
    opacity: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: all .4s ease-in-out 0s;
  }

  .left {
    float: left;
  }

  .img:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: all .4s ease-in-out 0s;
    border: 0 solid #fff;
  }

  .con {
    padding: 15px;
    overflow: hidden;
    height: 80px;
  }

  .con h4 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 15px;
    color: #262626;
    margin: 20px 0;
  }

  .con p {
    color: #6e6e6e;
    font-size: 12px;
    line-height: 20px;
    height: 80px;
    overflow: hidden;
  }

  .con .more {
    margin-top: 25px;
    display: block;
    height: 40px;
    width: 120px;
    background: #fff;
    border: 1px solid #eee;
    text-align: center;
    transition: all .3s ease-in-out 0s;
  }

  .con .more span {
    text-transform: uppercase;
    opacity: 0;
    width: 0;
    display: inline-block;
    overflow: hidden;
    color: #fff;
    line-height: 38px;
    vertical-align: middle;
    transition: all .3s ease-in-out 0s;
    font-size: 14px;
  }

  .con .more:after {
    content: "";
    background: url(../assets/img/ico-4.png) no-repeat;
    width: 16px;
    height: 7px;
    display: inline-block;
    vertical-align: middle;
  }
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #fff;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }

    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;

      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}

.text-center {
  text-align: center;
}

.container2 {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 90%;

  ::v-deep.el-carousel__container {
    height: 300px !important;
  }

  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }



  .mt50 {
    margin-top: 50px;
  }

  .fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

  .tit-box h4 {
    font-size: 26px;
    margin: 0 0 10px 0;
    font-weight: bold;
    color: #333;
  }

  .tit-box p {
    font-size: 14px;
    color: #B7B7B7;
    text-transform: uppercase;
  }

  .row {
    margin-right: -15px;
    margin-left: -15px;
  }

  .ys-body {
    margin: 30px 0 0 0;
  }

  .ys-body li {
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    visibility: visible;
    animation-name: fadeInUp;
  }

  .col-md-8 {
    width: 60%;
    margin-right: 5%;
    float: left;
  }

  .ys-con,
  .ys-img {
    padding: 20px 0;
  }

  .ys-con h4 {
    font-size: 20px;
    font-weight: 700;
    margin: 6px 0 15px;
    color: #005eae;
  }

  .ys-con h4 span {
    font-family: Arial;
    font-size: 30px;
    position: relative;
    top: 5px;
    padding: 0 10px 0 0;
  }

  .ys-con p {
    font-size: 13px;
    line-height: 24px;
    height: 122px;
    overflow: hidden;
    color: #666;
  }

  .ys-con a {
    display: block;
    display: block;
    height: 40px;
    width: 120px;
    background: #ddd;
    text-align: center;
    line-height: 38px;
    color: #666;
    margin: 50px 0 0 0;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.3s;
  }

  .ys-con a:hover {
    color: #fff;
    background: #005eae;
  }

  .col-md-4 {
    width: 30%;
    float: left;
  }

  .ys-img img {
    width: 100%;

    border: none;
  }
}
</style>